import { Component, Input, OnChanges } from '@angular/core';
import { IconService } from '@core/services/icon.service';

@Component({
    selector: 'bws-mdi',
    template: `
    <span [innerHTML]="svgIcon|async"></span>
  `,
    styles: [
        `
      :host {
        display: inline-block;
        color: inherit;
        font-style: normal;
        line-height: 0;
        text-align: center;
        text-transform: none;
        text-rendering: optimizelegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        svg, span {
          line-height: 1;
          display: inline-block;
        }
      }
    `
    ],
    standalone: false
})
export class MdiComponent implements OnChanges {

  @Input() name!: string;
  svgIcon = this.iconService.getIcon(this.name);

  constructor(private iconService: IconService) {}

  ngOnChanges(): void {
    this.svgIcon = this.iconService.getIcon(this.name);
  }

}
